import { SET_FREE_SHIPPING_OPTIONS } from 'store/action-types/shipping.action-types';

export type ShippingReducer = {
  freeOptions: string[];
};

const initialState: ShippingReducer = {
  freeOptions: [],
};

const shippingReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FREE_SHIPPING_OPTIONS: {
      return {
        ...state,
        freeOptions: action.data,
      };
    }
    default: {
      return state;
    }
  }
};

export default shippingReducer;
